/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.directives {
    export interface IStatusHistoryScope extends ng.IScope {
        manageSection: Wars.Domain.Model.ManageSection;
        isConfigureMode: boolean;
        isEditMode: boolean;
        expandAll: any;
        collapseAll: any;
        getStatusExpandCollapseClass: (x) => string;
        getStateExpandCollapseClass: (x, y) => string;
        isStatusExpanded: (x) => boolean;
        isStateExpanded: (x, y) => boolean;
        expandStatus: (x) => void;
        expandState: (x, y) => void;
        save: any;
        maxDepth: number;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        editSecurityMatrix: () => void;
        processConfigurationId: string;
        hideCommentsAndAttachments: () => void;
        showCommentsAndAttachments: () => void;
        showDocumentsAndComments: boolean;
    }

    export class StatusHistory implements IDirective {
        public link($scope: IStatusHistoryScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/manageForm/statusHistory.html';
        public controller = ['$scope', 'formService','securityMatrixService', StatusHistoryController];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            manageSection: "=",
            process: "=",
            processConfigurationId:"="
        };
    }

    export class StatusHistoryController {
        private statusExpanded: Array<boolean>;
        private stateExpanded: Array<Array<boolean>>;

        constructor(private scope: IStatusHistoryScope,
            private formService: services.FormService,
            private securityMatrixService: services.SecurityMatrixService)
        {
            scope.getStatusExpandCollapseClass = (i) => this.getStatusExpandCollapseClass(i);
            scope.getStateExpandCollapseClass = (x, y) => this.getStateExpandCollapseClass(x, y);
            scope.expandStatus = (i) => this.expandStatus(i);
            scope.expandState = (i, x) => this.expandState(i, x);
            scope.isStatusExpanded = (i) => this.isStatusExpanded(i);
            scope.isStateExpanded = (x, y) => this.isStateExpanded(x, y);
            scope.expandAll = () => this.expandAll();
            scope.collapseAll = () => this.collapseAll();
            scope.hideCommentsAndAttachments = () => this.hideCommentsAndAttachments();
            scope.showCommentsAndAttachments = () => this.showCommentsAndAttachments();
            scope.save = () => this.save();
            scope.editSecurityMatrix = () => this.editSecurityMatrix();

            scope.showDocumentsAndComments = true;

            if (this.scope.process) {
                this.statusExpanded = [];
                this.stateExpanded = [];
                for (var statusIndex = 0; statusIndex < this.scope.process.statusHistories.length; statusIndex++) {
                    var status = this.scope.process.statusHistories[statusIndex];
                    this.statusExpanded.push(false);
                    this.stateExpanded.push([]);
                    for (var stateIndex = 0; stateIndex < status.myStateHistory.length; stateIndex++) {
                        this.stateExpanded[statusIndex][stateIndex] = false;
                    }
                }

                if (this.scope.manageSection.manageStatusConfiguration.autoExpand) {
                    this.expandAll();
                }

                if (this.scope.manageSection.manageStatusConfiguration.allowThreadedComments) {
                    this.scope.maxDepth = 4;
                } else {
                    this.scope.maxDepth = 0;
                }
            }
        }

        private editSecurityMatrix() {
            if (!this.scope.manageSection.manageStatusConfiguration.securityMatrixForRespondingToComments) {
                this.scope.manageSection.manageStatusConfiguration.securityMatrixForRespondingToComments = this.securityMatrixService.createSecurityMatrix(false, false);
                this.save();
            }

            this.securityMatrixService.openSecurityMatrixModal(this.scope.manageSection.manageStatusConfiguration.securityMatrixForRespondingToComments,this.scope.processConfigurationId);
        }

        private save() {
            this.formService.saveAllChanges();
        }

        public expandAll(): void {
            for (var i = 0; i < this.statusExpanded.length; i++) {
                this.statusExpanded[i] = true;
                for (var x = 0; x < this.stateExpanded[i].length; x++) {
                    this.stateExpanded[i][x] = true;
                }
            }
        }

        public collapseAll(): void {
            for (var i = 0; i < this.statusExpanded.length; i++) {
                this.statusExpanded[i] = false;
                for (var x = 0; x < this.stateExpanded[i].length; x++) {
                    this.stateExpanded[i][x] = false;
                }
            }
        }

        public hideCommentsAndAttachments(): void {
            this.scope.showDocumentsAndComments = false;
        }

        public showCommentsAndAttachments(): void {
            this.scope.showDocumentsAndComments = true;
        }

        public getStatusExpandCollapseClass(index: number): string {
            return this.isStatusExpanded(index) ? '' +
                '' +
                'glyphicon-expand' : 'glyphicon-collapse-down';
        }

        public getStateExpandCollapseClass(statusIndex: number, stateIndex: number): string {
            return this.isStateExpanded(statusIndex, stateIndex) ? 'glyphicon-expand' : 'glyphicon-collapse-down';
        }

        public isStatusExpanded(index: number): boolean {
            return this.statusExpanded[index];
        }

        public isStateExpanded(statusIndex: number, stateIndex: number): boolean {
            if (this.stateExpanded && this.stateExpanded[statusIndex] && this.stateExpanded[statusIndex][stateIndex]) {
                return this.stateExpanded[statusIndex][stateIndex];
            }

            return false;
        }

        public expandStatus(index: number) {
            this.statusExpanded[index] = !this.statusExpanded[index];
        }

        public expandState(statusIndex: number, stateIndex: number) {
            this.stateExpanded[statusIndex][stateIndex] = !this.stateExpanded[statusIndex][stateIndex];
        }
    }
}
warsApp.registerDirective('StatusHistory', []);